export default __webpack_public_path__ + "static/media/Q22020.52e8b9a2.PDF";